import { apiClient } from './client';
import type { SharedLinkClaimRequest, SharedLinkClaimResponse } from './types';

export const sharedLinksApi = {
  claim: async (data: SharedLinkClaimRequest): Promise<SharedLinkClaimResponse> => {
    const response = await apiClient.post('/v1/shared-links/claim', data);
    return response.data;
  },

  /**
   * Shared-pool domains a workspace may shorten onto when it has none of its
   * own. The backend owns the list, so this asks rather than keeping a copy.
   */
  domains: async (): Promise<string[]> => {
    const response = await apiClient.get('/v1/shared-links/domains');
    return response.data?.domains ?? [];
  },
};
